import AgentDownloadInstallWindows from './AgentDownloadInstallWindows';
import { AGENT_OS_DOCKER_MAC, AGENT_OS_MAC, AGENT_OS_LINUX, AGENT_OS_WINDOWS } from './AgentConstants';
import AgentDownloadInstallLinux from './AgentDownloadInstallLinux';
import AgentDownloadInstallMacos from './AgentDownloadInstallMacos';
import { usePrimaryXMSLocation } from '../../../stores/EnvironmentStore';

const INSTALL_COMPONENT = {
    [AGENT_OS_WINDOWS]: AgentDownloadInstallWindows,
    [AGENT_OS_LINUX]: AgentDownloadInstallLinux,
    [AGENT_OS_DOCKER_MAC]: AgentDownloadInstallLinux,
    [AGENT_OS_MAC]: AgentDownloadInstallMacos,
};

/** @param {import('./AgentDownloadDialog').WizardProps} props */
export default function AgentDownloadWizardInstall({ wizardSelections }) {
    const [primaryXmsLocation] = usePrimaryXMSLocation();
    const AgentDownloadComponent = INSTALL_COMPONENT[wizardSelections.current.os];

    return <AgentDownloadComponent wizardSelections={wizardSelections} primaryXmsLocation={primaryXmsLocation} />;
}
